import React from 'react';
import SplideSlider from '@components/SplideSlider';
import { getAssetUrl } from '@utils/getAssetUrl';
import { ImageObj } from '../../../../types/ImageObj.types';
import cn from './style.module.scss';

interface WelcomeSliderProps {
  slideImages: ImageObj[];
}
const welcomeSliderSettings = {
  type: 'fade',
  rewind: true,
  autoplay: true,
  speed: 1000,
  perMove: 1,
  perPage: 1,
  start: 1,
  drag: false,
};
export default function WelcomeSlider(props: WelcomeSliderProps) {
  return (
    <div className={cn.luxuryGRDSlide}>
      <SplideSlider className="welcomeSlider" options={welcomeSliderSettings}>
        {props.slideImages.map((image, index) => (
          <img key={index} src={image.url} alt={image.alt} />
        ))}
      </SplideSlider>
    </div>
  );
}
